import AmericanExpressLogo from '@/assets/bank-logos-v2/American Express.svg';
import AmeriHomeMortgageLogo from '@/assets/bank-logos-v2/AmeriHome Mortgage.svg';
import AmerisBankLogo from '@/assets/bank-logos-v2/Ameris Bank.svg';
import BankOfAmericaLogo from '@/assets/bank-logos-v2/Bank of America.svg';
import BettermentLogo from '@/assets/bank-logos-v2/Betterment.svg';
import CapitalOneLogo from '@/assets/bank-logos-v2/Capital One.svg';
import CarringtonMortgageLogo from '@/assets/bank-logos-v2/Carrington Mortgage.svg';
import CharlesSchwabLogo from '@/assets/bank-logos-v2/Charles Schwab.svg';
import ChaseLogo from '@/assets/bank-logos-v2/Chase.svg';
import ChimeLogo from '@/assets/bank-logos-v2/Chime.svg';
import CitiLogo from '@/assets/bank-logos-v2/Citibank.svg';
import CitizensBankLogo from '@/assets/bank-logos-v2/Citizens Bank.svg';
import CMGHomeLoanLogo from '@/assets/bank-logos-v2/CMG Home Loans.svg';
import CrossCountryMortgageLogo from '@/assets/bank-logos-v2/CrossCountry Mortgage.svg';
import FifthThirdBankLogo from '@/assets/bank-logos-v2/Fifth Third Bank.svg';
import FirstCitizensBankLogo from '@/assets/bank-logos-v2/First Citizens Bank.svg';
import FlagstarBankLogo from '@/assets/bank-logos-v2/Flagstar Bank.svg';
import FreedomMortgageLogo from '@/assets/bank-logos-v2/Freedom Mortgage.svg';
import FrostBankLogo from '@/assets/bank-logos-v2/Frost Bank.svg';
import GuildMortgageLogo from '@/assets/bank-logos-v2/Guild Mortgage.svg';
import HomePointFinancialCorporationLogo from '@/assets/bank-logos-v2/Home Point Financial Corporation.svg';
import HuntingtonBankLogo from '@/assets/bank-logos-v2/Huntington Bank.svg';
import IndependentBankLogo from '@/assets/bank-logos-v2/Independent Bank.svg';
import KiaviLogo from '@/assets/bank-logos-v2/Kiavi.svg';
import LakeMichiganCreditUnionLogo from '@/assets/bank-logos-v2/Lake Michigan Credit Union.svg';
import LakeviewLoanServicingLogo from '@/assets/bank-logos-v2/Lakeview Loan Servicing.svg';
import LoanDepotLogo from '@/assets/bank-logos-v2/Loan Depot.svg';
import LoanCareLogo from '@/assets/bank-logos-v2/LoanCare.svg';
import MTBankCorporationLogo from '@/assets/bank-logos-v2/M&T Bank Corporation.svg';
import MercantileBankLogo from '@/assets/bank-logos-v2/Mercantile Bank.svg';
import MovementMortgageLogo from '@/assets/bank-logos-v2/Movement Mortgage.svg';
import MrCooperLogo from '@/assets/bank-logos-v2/Mr. Cooper.svg';
import NavyFederalLogo from '@/assets/bank-logos-v2/Navy Federal Credit Union.svg';
import NewRezRithmLogo from '@/assets/bank-logos-v2/NewRez Rithm.svg';
import OldNationalLogo from '@/assets/bank-logos-v2/Old National Bank.svg';
import OnityGroupLogo from '@/assets/bank-logos-v2/Onity Group.svg';
import PennymacLogo from '@/assets/bank-logos-v2/Pennymac.svg';
import PHHMortgageLogo from '@/assets/bank-logos-v2/PHH Mortgage.svg';
import PlanetHomeLendingLogo from '@/assets/bank-logos-v2/Planet Home Lending.svg';
import PNCBankLogo from '@/assets/bank-logos-v2/PNC.svg';
import RandolphBrooksLogo from '@/assets/bank-logos-v2/Randolph Brooks Federal Credit Union.svg';
import RegionsBankLogo from '@/assets/bank-logos-v2/Regions Bank.svg';
import RocketMortgageLogo from '@/assets/bank-logos-v2/Rocket Mortgage.svg';
import RoundpointMortgageLogo from '@/assets/bank-logos-v2/Roundpoint Mortgage.svg';
import SelectPortfolioServicingLogo from '@/assets/bank-logos-v2/Select Portfolio Servicing.svg';
import ShellpointMortgageLogo from '@/assets/bank-logos-v2/Specialized Loan Servicing serviced by Shellpoint.svg';
import TDBankLogo from '@/assets/bank-logos-v2/TD Bank.svg';
import TruistLogo from '@/assets/bank-logos-v2/Truist.svg';
import USBankLogo from '@/assets/bank-logos-v2/U.S. Bank.svg';
import UnitedWholesaleMortgageLogo from '@/assets/bank-logos-v2/United Wholesale Mortgage.svg';
import USAALogo from '@/assets/bank-logos-v2/USAA.svg';
import WellsFargoLogo from '@/assets/bank-logos-v2/Wells Fargo.svg';

const bankLogoRepository = {
    'American Express': AmericanExpressLogo,
    'AmeriHome Mortgage': AmeriHomeMortgageLogo,
    'Ameris Bank': AmerisBankLogo,
    'Bank of America': BankOfAmericaLogo,
    Betterment: BettermentLogo,
    'Capital One': CapitalOneLogo,
    'Carrington Mortgage': CarringtonMortgageLogo,
    'Charles Schwab': CharlesSchwabLogo,
    Chase: ChaseLogo,
    Chime: ChimeLogo,
    'Citibank Online': CitiLogo,
    'Citizens Bank': CitizensBankLogo,
    'CMG Home Loans': CMGHomeLoanLogo,
    'Cross Country Mortgage': CrossCountryMortgageLogo,
    'Fifth Third Bank': FifthThirdBankLogo,
    'First Citizens Bank': FirstCitizensBankLogo,
    'Flagstar Bank': FlagstarBankLogo,
    'Freedom Mortgage': FreedomMortgageLogo,
    'Frost Bank': FrostBankLogo,
    'Guild Mortgage': GuildMortgageLogo,
    'Home Point Financial Corporation': HomePointFinancialCorporationLogo,
    'Huntington Bank': HuntingtonBankLogo,
    'Independent Bank': IndependentBankLogo,
    Kiavi: KiaviLogo,
    'Lake Michigan Credit Union': LakeMichiganCreditUnionLogo,
    'Lakeview Loan Servicing': LakeviewLoanServicingLogo,
    'Loan Depot': LoanDepotLogo,
    LoanCare: LoanCareLogo,
    'M&T Bank Corporation': MTBankCorporationLogo,
    'Mercantile Bank': MercantileBankLogo,
    'Movement Mortgage': MovementMortgageLogo,
    'Mr. Cooper': MrCooperLogo,
    'Navy Federal Credit Union': NavyFederalLogo,
    'Newrez Rithm': NewRezRithmLogo,
    'Old National Bank': OldNationalLogo,
    'Onity Group': OnityGroupLogo,
    Pennymac: PennymacLogo,
    'PHH Mortgage': PHHMortgageLogo,
    'Planet Home Lending': PlanetHomeLendingLogo,
    'PNC Bank': PNCBankLogo,
    'Randolph Brooks Federal Credit Union': RandolphBrooksLogo,
    'Regions Bank': RegionsBankLogo,
    'Rocket Mortgage': RocketMortgageLogo,
    'Roundpoint Mortgage': RoundpointMortgageLogo,
    'Select Portfolio Servicing': SelectPortfolioServicingLogo,
    'Specialized Loan Servicing serviced by Shellpoint': ShellpointMortgageLogo,
    'TD Bank': TDBankLogo,
    'Truist Bank': TruistLogo,
    'U.S. Bank': USBankLogo,
    'United Wholesale Mortgage': UnitedWholesaleMortgageLogo,
    USAA: USAALogo,
    'Wells Fargo': WellsFargoLogo,
} as const;

export type InstitutionName = keyof typeof bankLogoRepository;

export const bankLogoRepositoryMap = new Map(Object.entries(bankLogoRepository));
